import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { sanitizeEmailHtml } from '../../lib/emailHtml';

/** An email's HTML, for messages with no plain body. Always sanitised here. */
export function EmailHtmlBody({ html, className }: { html: string; className?: string }) {
  const clean = useMemo(() => sanitizeEmailHtml(html), [html]);
  return (
    <div
      data-email-html
      className={cn(
        'max-w-full overflow-x-auto [overflow-wrap:anywhere]',
        '[&_p]:mb-2 last:[&_p]:mb-0 [&_a]:underline [&_a]:text-primary',
        '[&_ul]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:mb-2 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_blockquote]:border-l-2 [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
